<template>
  <div>
    <v-dialog fullscreen persistent v-model="dialog" width="500">
      <template v-slot:activator="{ on }">
        <v-btn color="primary" rounded style="color: black" v-on="on">
          Click To Transfer
        </v-btn>
      </template>
      <v-card>
        <v-toolbar color="primary">
          <v-toolbar-title>Transfer token</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
              icon
              @click="
                resetForm();
                dialog = false;
              "
              :disabled="isStart"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text style="height: calc(100vh - 150px); overflow: auto">
          <div class="pa-3">
            <v-layout
              wrap
              style="border: 1px solid grey; border-radius: 5px"
              class="pa-3"
            >
              <v-flex xs12 sm6 class="pa-1">
                <v-text-field
                  v-model="searchForm.searchedCode"
                  label="Search Reference source"
                ></v-text-field
              ></v-flex>
              <v-flex xs12 sm6 class="pa-1">
                <v-text-field
                  v-model="searchForm.searchedName"
                  label="Search Reference name"
                ></v-text-field></v-flex
              ><v-flex xs12 sm6 class="pa-1">
                <v-text-field
                  v-model="searchForm.searchedWalletAddress"
                  label="Search wallet address"
                ></v-text-field
              ></v-flex>
              <v-flex xs12 sm6 class="pa-1">
                <v-text-field
                  v-model="searchForm.searchedType"
                  label="Search type"
                ></v-text-field
              ></v-flex>
              <v-flex xs12 sm6 class="pa-1">
                <v-select
                  :items="filterList"
                  item-text="name"
                  item-value="value"
                  v-model="searchForm.filterStatusForm"
                ></v-select></v-flex
            ></v-layout>
          </div>

          <v-data-table
            v-model="collectQueueId"
            :headers="headers"
            :items="searchQueueList"
            item-key="queue_id"
            :isLoading="isLoading"
            :rows-per-page-items="[10, 50]"
            select-all
          >
            <template v-slot:items="props">
              <tr>
                <td>
                  <v-checkbox
                    v-model="props.selected"
                    primary
                    hide-details
                    color="primary"
                  ></v-checkbox>
                </td>
                <td class="text-xs-center">
                  {{ props.item.queue_type }}
                </td>

                <td>
                  {{ props.item.queue_user_wallet_address }}
                </td>

                <td
                  style="color: red; white-space: nowrap"
                  class="text-xs-center"
                >
                  - {{ props.item.queue_amount_point }}
                </td>
                <td
                  style="color: green; white-space: nowrap"
                  class="text-xs-center"
                >
                  + {{ props.item.queue_amount_token }}
                </td>
                <td
                  class="text-xs-center"
                  :style="{
                    color:
                      props.item.queue_status == 1
                        ? 'orange'
                        : props.item.queue_status == 2
                        ? 'green'
                        : props.item.queue_status == 3
                        ? 'red'
                        : props.item.queue_status == 4
                        ? 'purple'
                        : '',
                  }"
                >
                  {{
                    props.item.queue_status == 1
                      ? "Pending"
                      : props.item.queue_status == 2
                      ? "Success"
                      : props.item.queue_status == 3
                      ? "Failed"
                      : props.item.queue_status == 4
                      ? "Canceled"
                      : ""
                  }}
                </td>
                <td>
                  {{ props.item.queue_name }}
                </td>
                <td>
                  {{ props.item.queue_code }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pr-4">
          <v-spacer></v-spacer>
          <v-btn
            style="text-decoration: underline"
            @click="resetForm()"
            :disabled="isStart"
            flat
            color="error"
          >
            reset
          </v-btn>
          <v-btn
            @click="submit()"
            color="primary"
            class="elevation-2"
            :loading="isStart"
            style="color: black; border-radius: 5px"
          >
            transfer
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="transferDialog" persistent max-width="70vw">
      <v-card
        ><v-card-title
          style="display: flex; justify-content: space-between; font-size: 24px"
        >
          <span v-if="isCancel == true && isTransfering == true"
            >TRANSFER CANCELING</span
          >
          <span v-else-if="isCancel == true && isTransfering == false"
            >TRANSFER CANCELED</span
          >
          <span v-else-if="isStart == true">TRANSFERING...</span
          ><span v-else-if="isStart == false">TRANSFERING COMPLETE</span>

          <div>
            <span class="pr-1" style="font-weight: bold; color: grey"
              >Progress:</span
            >
            <span class="pr-2" style="font-weight: bold"
              >{{ successList.length + failedList.length }} of
              {{ collectQueueId.length }}</span
            >
            <span style="color: #3498db; font-weight: bold"
              >({{
                (
                  ((successList.length + failedList.length) * 100) /
                  collectQueueId.length
                ).toFixed(2)
              }}
              %)</span
            >
          </div>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <div class="pb-3" style="font-weight: bold; font-size: 22px">
            Success: <span style="color: green">{{ successList.length }}</span>
          </div>
          <div class="" style="font-weight: bold; font-size: 22px">
            Failed: <span style="color: red">{{ failedList.length }}</span>
          </div>
          <div style="display: flex; justify-content: flex-end">
            <v-btn
              v-if="
                isStart == true &&
                collectQueueId.length > successList.length + failedList.length
              "
              @click="isCancel = true"
              flat
              style="
                border-radius: 5px;
                width: 180px;
                height: 40px;
                background-color: red;
              "
              :loading="isCancel"
              ><span style="font-weight: bold; color: white"
                >CANCEL</span
              ></v-btn
            >
            <v-btn
              v-else
              @click="
                transferDialog = false;
                dialog = false;
                resetTransferForm();
                collectQueueId = [];
                isCancel = false;
                $emit('onOK');
              "
              flat
              style="
                border-radius: 5px;
                width: 180px;
                height: 40px;
                background-color: #fddf00;
              "
              :disabled="isCancel && isTransfering == true"
              ><span style="font-weight: bold">OK</span></v-btn
            >
          </div>
        </v-card-text>
      </v-card></v-dialog
    >
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: [
    "searchForm",
    "filterList",
    "searchQueueList",
    "isLoading",
    "headers",
    "queueList",
  ],
  data() {
    return {
      transferDialog: false,
      valid: true,
      dialog: false,
      collectQueueId: [],
      successList: [],
      failedList: [],
      intervalTransfer: null,
      transferIndex: 0,
      isTransfering: false,
      isCancel: false,
      isStart: false,
    };
  },
  computed: {},
  watch: {
    dialog(newValue, oldValue) {
      if (this.dialog == true) {
        this.isTransfering = false;
        this.collectQueueId = [];
        this.transferIndex = 0;
      }
    },
  },
  methods: {
    ...mapActions({
      transferToken: "crypto/transferToken",
    }),
    resetForm() {
      this.collectQueueId = [];
    },
    resetTransferForm() {
      this.successList = [];
      this.failedList = [];
      this.transferIndex = 0;
    },
    async submit() {
      this.transferDialog = true;

      let _this = this;
      this.isStart = true;
      this.intervalTransfer = setInterval(function () {
        _this.transfer();
      }, 1000);

      // this.dialog = false;
      // this.collectQueueId = [];
    },
    async transfer() {
      // failed case: response == false stop transfer
      // passed case: transfer failed continue transfer
      // passed case: tansfer passed continue transfer
      // passed case: transfered all transaction to stop

      if (this.isTransfering == true) return;
      if (
        this.isCancel == true ||
        this.collectQueueId.length <=
          this.successList.length + this.failedList.length
      ) {
        this.isStart = false;
        this.isTransfering = false;
        clearInterval(this.intervalTransfer);
        return;
      }
      let payload = {
        queues: [
          {
            queue_id: this.collectQueueId[this.transferIndex].queue_id,
            queue_user_wallet_address:
              this.collectQueueId[this.transferIndex].queue_user_wallet_address,
            queue_amount_token:
              this.collectQueueId[this.transferIndex].queue_amount_token,
          },
        ],
      };

      this.isTransfering = true;
      let response = await this.transferToken(payload);
      this.isTransfering = false;
      if (response == false) {
        this.isCancel = true;
        return;
      }

      this.successList = [...this.successList, ...response.data.queue_complete];
      this.failedList = [...this.failedList, ...response.data.queue_fail];

      this.transferIndex++;
    },
  },
};
</script>

<style scoped>
.loading-section {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
}
.loading-item {
  animation: fade 2s infinite linear;
}
.loading-item-span {
  font-size: 28px;
}
</style>